import { inject, Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';

@Injectable()
export abstract class AnalyticsToolBaseService {
    private readonly appConfig = inject(AppConfig);

    protected isMixpanelExcludedUser(userEmail: string): boolean {
        const excludedEmails = (this.appConfig.settings?.settings?.mixpanel_exclude_users as string[]) || [];
        return Boolean(excludedEmails.find((email) => email === userEmail));
    }
}
